var map = {
	"./bishop/diagnosis/diagnosis_a.png": "2fce",
	"./bishop/pre-initiation/pre-initiation_a.png": "73db",
	"./bishop/ramp-up/ramp-up_a.png": "973a",
	"./bishop/risk-assessment/risk-assessment_a.png": "480e",
	"./carson/cycle-1/cycle-1_a.png": "49a3",
	"./carson/cycle-2/cycle-2_a.png": "1989",
	"./carson/cycle-3/cycle-3_a.png": "6ee1",
	"./carson/diagnosis/diagnosis_a.png": "febf",
	"./gordon/cycle-3/cycle-3_a.png": "4da2",
	"./gordon/cycle-4/cycle-4_a.png": "dcdb",
	"./gordon/diagnosis/diagnosis_a.png": "5dd8",
	"./pierce/cycle-1/cycle-1_a.png": "c6e6",
	"./pierce/diagnosis/diagnosis_a.png": "c462",
	"./pierce/pre-initiation/pre-initiation_a.png": "bc19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c726";